import Sticky from "react-stickynode"
import styled from "styled-components"
import { useRouter } from "next/router"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"

import ResetCSS from "@/common/assets/css/style"
import MetaData from "@/common/components/MetaData"
import NavbarNew from "@/containers/common/NavbarNew"
import Footer from "@/containers/common/FooterNew"
import Intro from "@/common/components/_UI/Intro"
import SectionRow from "@/common/components/_Section/SectionRow"
import Buttons from "@/common/components/_UI/Buttons"
import { BGWrapper } from "@/common/Mixin"
import GlowBox from "@/common/components/GlowBG"

export default function Complete() {
  const { t } = useTranslation(["complete", "common"])
  const { locale } = useRouter()
  return (
    <>
      <MetaData
        title={t("complete.meta.title")}
        description={t("complete.meta.desc")}
        url={t("complete.url")}
        image="https://i.ibb.co/5hTTfS2/og-image-compliance.jpg"
        languageAlternates={[
          [
            {
              hrefLang: "en-US",
              href: "https://www.kryptogo.com/contact/complete"
            },
            {
              hrefLang: "zh-TW",
              href: "https://www.kryptogo.com/tw/contact/complete"
            },
            {
              hrefLang: "zh-CN",
              href: "https://www.kryptogo.com/cn/contact/complete"
            }
          ]
        ]}
      />
      <ResetCSS />
      <Sticky top={0} innerZ={1000} activeClass="sticky-active">
        <NavbarNew />
      </Sticky>
      <BGWrapper className={"fixed"}>
        <GlowBox></GlowBox>
      </BGWrapper>
      <Wrapper>
        <SectionRow
          content1={
            <>
              <Intro
                center
                big
                title2={t("contact.complete.title")}
                desc={t("contact.complete.desc")}
              />
            </>
          }
          content2={
            <Buttons
              center
              btns={[{ content: t("contact.button"), href: "/" }]}
            />
          }
        />
      </Wrapper>
      <Footer></Footer>
    </>
  )
}
export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "complete",
      "contactUs",
      "common"
    ]))
  }
})

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
  h1 {
    font-size: 80px;
  }
`
